<script setup lang="ts">
const props = defineProps<{ level: LevelName }>();

const { filters, posts, pending } = usePosts({ level: props.level });
</script>

<template>
  <div class="relative min-h-16 flex flex-col gap-6">
    <PostGridFilters v-model:workshop="filters.workshop" :level="level" />
    <div v-if="posts.length" class="grid gap-6 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
      <PostGridItem v-for="post in posts" :key="post.id" :post="post" />
    </div>
    <div v-else class="text-center text-muted font-bold text-2xl">
      {{ __("No content to display.", 'egalite') }}
    </div>
    <div v-if="pending" class="absolute inset-0 bg-white/50 flex items-center justify-center">
      <span class="i-lucide-loader size-12 animate-spin" />
    </div>
  </div>
</template>
